// extracted by mini-css-extract-plugin
module.exports = {"form":"styles-module--form--1oRCJ","input":"styles-module--input--28md6","button":"styles-module--button--2u7Vy"};